// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_529Ps","warp":"warp_oShTM","title":"title_arkfi","desc":"desc_Et55-","icon":"icon_c7Ny4"};